import React from 'react';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { IconArrowLeft } from '../../icons/svg';
import { SCREEN } from '../info-view-content.jsx';
import { Tinode } from '../../tinode/tinode';
import { Topic } from '../../tinode/topic';
import { GROUP_ROLE, NODE_TYPE_MESSAGE } from '../../tinode/constants';
import MemberItem from './member-item.jsx';
import GroupService from '../../services/group.js';
import MessagesUtil from '../../tinode/messagesUtils.js';
import LetterTile from '../letter-tile.jsx';
import Helpers from '../../lib/helpers.js';

const SET_PENDING_MEMBER_ACTION = {
  DECLINE: 0,
  APPROVE: 1,
}

const messages = defineMessages({
  decline: {
    id: "decline",
    defaultMessage: "Decline",
    description: "Decline",
  },
  approve: {
    id: "approve",
    defaultMessage: "Approve",
    description: "Approve",
  },
  info_pending_members: {
    id: "info_pending_members",
    defaultMessage: "Pending members",
    description: "Pending members",
  },
  notify_decline_success: {
    id: "notify_decline_success",
    defaultMessage: "Member Rejected Successfully",
    description: "Member Rejected Successfully",
  },
  add_member_success: {
    id: "add_member_success",
    defaultMessage: "Add member success",
    description: "Add member success",
  },
  notify_error: {
		id: "notify_error",
		defaultMessage: "An error occurred. Please try again later",
		description: "Notify error",
  },
})

class Members extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      listPendingMembers: []
    }

    this.renderListContact = this.renderListContact.bind(this);
    this.renderListPendingMember = this.renderListPendingMember.bind(this);
    this.handleOpenModalInfo = this.handleOpenModalInfo.bind(this);
    this.getListMember = this.getListMember.bind(this);
    this.updateListPendingMember = this.updateListPendingMember.bind(this);
    this.setPendingMemberAction = this.setPendingMemberAction.bind(this);
  }

  componentDidMount() {
    if (this.props.admin) {
      this.updateListPendingMember()
    }
  }

  async updateListPendingMember() {
    const groupId = Topic.getThreadId(this.props.topic)
    const listPendingMembers = await GroupService.getPendingMember(groupId)
    window.logger(listPendingMembers)
    if (listPendingMembers && listPendingMembers.code === 200) {
      const pendingMembers = listPendingMembers.pendingMembers
      this.setState({ listPendingMembers: pendingMembers })
    }
  }

  getListMember() {
    const { groupMembers } = this.props;
    if (groupMembers && groupMembers.length > 0) {
      return {
        listMembers: groupMembers.filter(item => item.role === GROUP_ROLE.MEMBER),
        listAdmins: groupMembers.filter(item => item.role === GROUP_ROLE.ADMIN),
      }
    }
    return {
      listMembers: [],
      listAdmins: []
    }
  }

  handleOpenModalInfo(topic) {
    this.props.onShowDialog(Tinode.DIALOG_TYPE.PERSONAL_INFORMATION, { topicProfile: topic });
  }

  async setPendingMemberAction(groupId, msisdn, action) {
    const { formatMessage } = this.props.intl;

    const result = await GroupService.setPendingMemberAction(groupId, msisdn, action)
    console.log(result);
    if (result && result.code === 200) {
      this.updateListPendingMember()
      if (action === SET_PENDING_MEMBER_ACTION.DECLINE) {
        Helpers.showSuccessToasts(formatMessage(messages.notify_decline_success))
      } else if (action === SET_PENDING_MEMBER_ACTION.APPROVE) {
        Helpers.showSuccessToasts(formatMessage(messages.add_member_success))
        this.props.handleSetScreen(SCREEN.INFO)
      }
    } else {
      Helpers.showErrorToasts(formatMessage(messages.notify_error))
    }
    
  }

  renderListPendingMember() {
    const { formatMessage } = this.props.intl;

    const groupId = Topic.getThreadId(this.props.topic)

    if (Array.isArray(this.state.listPendingMembers) && this.state.listPendingMembers.length === 0) {
      return null
    }

    return (
      <div className="gr-member">
        <div className="title">
          <FormattedMessage
            id='info_pending_members'
            defaultMessage={'Pending members'}
          /> ({this.state.listPendingMembers.length})</div>
        <div className="list-members">
          {this.state.listPendingMembers.map((member) => {
            const msisdn = member.msisdn
            const topicId = MessagesUtil.getTopicId(NODE_TYPE_MESSAGE.CHAT, msisdn)
            const name = Topic.getTopicName(topicId)

            return (
              <div className='pending-member-container'>
                <div className="avatar">
                  <LetterTile
                    tinode={this.props.tinode}
                    avatar={member.avatar || true}
                    title={name}
                    topic={topicId}
                  />
                </div>
                <div className='member-info'>
                  <div className='name'>{member.name || name}</div>
                  <div className='button-list'>
                    <button
                      className='btn-decline'
                      onClick={() => this.setPendingMemberAction(groupId, msisdn, SET_PENDING_MEMBER_ACTION.DECLINE)}
                    >{formatMessage(messages.decline)}</button>
                    <button
                      className='btn-accept'
                      onClick={() => this.setPendingMemberAction(groupId, msisdn, SET_PENDING_MEMBER_ACTION.APPROVE)}
                    >{formatMessage(messages.approve)}</button>
                  </div>
                </div>

              </div>
            )
          })}
        </div>
      </div>
    )
  }

  renderListContact(contacts, isAdmin = false) {
    const { tinode, topic, onShowAlert } = this.props;
    const topicInfo = tinode.getTopicByName(topic);
    const isAdminGr = topicInfo?.isAdmin();
    return contacts.map((item, key) => {
      return (
        <MemberItem
          topic={topic}
          tinode={tinode}
          item={item}
          key={key}
          isAdmin={isAdmin}
          handleClick={() => this.handleOpenModalInfo(item.topic || item.user)}
          onShowAlert={onShowAlert}
          isAdminGr={isAdminGr}
        />
      )
    })
  }

  render() {
    const { listMembers, listAdmins } = this.getListMember()
    return (
      <div className="info-member">
        <div className="header" onClick={() => this.props.handleSetScreen(SCREEN.INFO)}>
          <div className="icon"><IconArrowLeft /></div>
          <div className="name">{this.props.title}</div>
        </div>
        <div className="scroll">
          {listAdmins.length > 0 &&
            <div className="gr-admin">
              <div className="title">
                <FormattedMessage
                  id='info_admin_user'
                  defaultMessage={'Admin user'}
                /> ({listAdmins.length})</div>
              <div className="list-members">
                {this.renderListContact(listAdmins, true)}
              </div>
            </div>
          }
          {listMembers.length > 0 &&
            <div className="gr-member">
              <div className="title">
                <FormattedMessage
                  id='info_members'
                  defaultMessage={'Members'}
                /> ({listMembers.length})</div>
              <div className="list-members">
                {this.renderListContact(listMembers)}
              </div>
            </div>
          }
          {
            this.props.admin && this.renderListPendingMember()
          }
        </div>
      </div>
    )
  }

}

export default injectIntl(Members);